export default {
  headerLogoOverflowMode: 'overflow',
  headerLogoMobileCentered: true,
  hasSiteSwitch: true,
};
